import React from 'react';
import { InfoTooltip } from '@components/main-components/tooltip/InfoTooltip';
import { MediaQuery } from '@context/mediaQuery';

export function ArtistFeeTooltip() {
  const { tabletLandscape } = MediaQuery.useContainer();
  return (
    <InfoTooltip delayCloseMs={1500} openOnClick={!tabletLandscape} variant="outlined" size={12}>
      <InfoTooltip.StyledContent className="!p-2 text-center md:!max-w-[240px]">
        100% of the artist fee goes to the artist to support their work.
      </InfoTooltip.StyledContent>
    </InfoTooltip>
  );
}
